import React from 'react';
import { ReportStatusCell, ReportStatusRowValue } from './ReportStatusCell';
import { AlignedReportValue } from '@/Pages/GenericWorklist/Logic/WorklistReportAlignmentHelper';
import { type OrderForWorklist } from '@/Models/GenericWorklist/WorklistResult';
import WorklistDataGridStore from '@/Pages/GenericWorklist/Components/DataGrid/WorklistDataGridStore';

interface ReportStatusColumnCellProps {
    order: OrderForWorklist;
    statusRows: readonly AlignedReportValue<ReportStatusRowValue>[];
    alignedReports: ({ ReportID: number; OrderProcedureIds: number[] } | null)[];
    dataGridStore?: WorklistDataGridStore;
}

export function ReportStatusColumnCell({ order, statusRows, alignedReports, dataGridStore }: Readonly<ReportStatusColumnCellProps>): React.ReactElement | null {
    const hasReportStatus = statusRows.some((row) => row.value.status !== null);

    return (
        <ReportStatusCell
            statusRows={statusRows}
            onClick={hasReportStatus
                ? (statusIndex) => {
                        const reportForStatus = alignedReports[statusIndex];
                        if (!reportForStatus) {
                            return;
                        }
                        dataGridStore?.setReportOrder(order, reportForStatus.ReportID, reportForStatus.OrderProcedureIds ?? []);
                    }
                : undefined}
        />
    );
}
